import React from 'react';
import { Badge } from '@/components/ui/badge';
import {
  Calendar,
  MapPin,
  Monitor,
  Laptop,
  Building2
} from 'lucide-react';

const BookingSummary = ({
  courseName,
  dates,
  location,
  duration,
  cost,
  delivery,
  provider
}) => {
  // Format date from dates array or single date
  const formatDate = (dates) => {
    if (!dates) return 'Date TBC';

    if (Array.isArray(dates) && dates.length > 0) {
      const firstDate = dates[0];
      if (firstDate.startDate) {
        return new Date(firstDate.startDate).toLocaleDateString('en-GB', {
          day: 'numeric',
          month: 'short',
          year: 'numeric'
        });
      }
    }

    if (typeof dates === 'string') {
      return new Date(dates).toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
      });
    }

    return 'Date TBC';
  };

  // Get delivery icon
  const getDeliveryIcon = () => {
    switch (delivery?.toLowerCase()) {
      case 'online':
        return <Monitor className="h-3.5 w-3.5" />;
      case 'hybrid':
        return <Laptop className="h-3.5 w-3.5" />;
      default:
        return <MapPin className="h-3.5 w-3.5" />;
    }
  };

  // Format delivery text
  const formatDelivery = () => {
    if (!delivery) return 'Onsite';
    return delivery.charAt(0).toUpperCase() + delivery.slice(1);
  };

  return (
    <div className="bg-gradient-to-br from-blue-50 to-blue-100/50 rounded-lg border border-blue-200 p-4">
      <h3 className="font-semibold text-base text-gray-900 mb-3">
        {courseName || 'Course Name Not Set'}
      </h3>

      <div className="grid grid-cols-2 gap-x-6 gap-y-2 text-sm">
        {/* Date */}
        <div className="flex items-center gap-2">
          <Calendar className="h-3.5 w-3.5 text-gray-500 flex-shrink-0" />
          <span className="text-gray-700">{formatDate(dates)}</span>
        </div>

        {/* Cost */}
        <div className="flex items-center gap-2">
          <span className="font-semibold text-gray-900">
            £{cost?.toLocaleString() || '0.00'}
          </span>
        </div>

        {/* Delivery Method */}
        <div className="flex items-center gap-2">
          {getDeliveryIcon()}
          <span className="text-gray-700">{formatDelivery()}</span>
        </div>

        {/* Provider */}
        {provider && (
          <div className="flex items-center gap-2">
            <Building2 className="h-3.5 w-3.5 text-gray-500 flex-shrink-0" />
            <span className="text-gray-700 truncate">{provider}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default BookingSummary;
